import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovaonrentmumbai() {



    const cardData = {





keyword: "Innova On Rent Mumbai",

headingDescription: "Shreesha Tours & Travels offers reliable and affordable Innova On Rent in Mumbai for airport transfers, family vacations, corporate travel, business meetings, wedding transportation, pilgrimage tours, sightseeing, one-way trips, round trips, and outstation journeys. Our well-maintained Toyota Innova vehicles provide spacious seating, comfortable interiors, ample luggage space, and a smooth ride, making them ideal for families and small groups. With professional chauffeurs, transparent pricing, doorstep pickup, flexible rental packages, and 24/7 customer support, we ensure a safe and hassle-free travel experience. Whether you are planning a weekend getaway, long-distance road trip, or corporate outing, our Mumbai Innova rental service delivers comfort, reliability, and convenience for every journey.",

topPlaces: [
  {
    title: "Mumbai to Pune",
    description: "Pune is one of the most preferred outstation destinations from Mumbai for business travel, family vacations, educational visits, and weekend getaways."
  },
  {
    title: "Mumbai to Goa",
    description: "Goa is a favorite destination for beach holidays, group tours, family vacations, and honeymoon trips, making an Innova an ideal choice for comfortable travel."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station known for strawberry farms, Venna Lake, viewpoints, and cool weather, perfect for family road trips."
  },
  {
    title: "Mumbai to Aurangabad",
    description: "Aurangabad attracts travelers visiting Ajanta Caves, Ellora Caves, Bibi Ka Maqbara, and Grishneshwar Jyotirlinga."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, vineyards, Panchavati, and religious attractions, making it a popular family destination."
  },
  {
    title: "Mumbai to Kolhapur",
    description: "Kolhapur is well known for Mahalaxmi Temple, Panhala Fort, local cuisine, and cultural heritage, attracting visitors throughout the year."
  },
  {
    title: "Mumbai to Ratnagiri",
    description: "Ratnagiri is a beautiful Konkan destination famous for Ganpatipule Temple, beaches, sea forts, and coastal landscapes."
  },
  {
    title: "Mumbai to Saputara",
    description: "Saputara is Gujarat's popular hill station offering lakes, ropeway rides, viewpoints, waterfalls, and peaceful surroundings."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, famous for Sai Baba Temple and nearby spiritual attractions."
  },
  {
    title: "Mumbai to Udaipur",
    description: "Udaipur, the City of Lakes, is known for magnificent palaces, heritage hotels, lakes, and royal Rajasthani architecture, making it ideal for long-distance family tours."
  }
],


"services": [
  {
    "name": "Innova On Rent Mumbai",
    "description": "Book Innova on Rent Mumbai for comfortable, spacious, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Ideal for airport transfers, outstation journeys, family vacations, corporate travel, group tours, and business meetings. Enjoy premium seating, ample luggage space, transparent pricing, and flexible rental packages for hourly, daily, one-way, and round-trip travel."
  },
  {
    "name": "Toyota Innova Rental Mumbai",
    "description": "Choose Toyota Innova Rental Mumbai for premium chauffeur-driven SUV services at competitive prices. Our Toyota Innova vehicles are perfect for family outings, airport pickups, sightseeing tours, office travel, long-distance journeys, and special occasions, ensuring maximum comfort and safety throughout your trip."
  },
  {
    "name": "Innova Cab Mumbai",
    "description": "Hire Innova Cab Mumbai for dependable local and outstation transportation with experienced drivers and clean AC vehicles. Travel comfortably for business meetings, airport transfers, family functions, religious tours, and weekend trips while enjoying spacious seating and smooth rides."
  },
  {
    "name": "Innova Car Hire Mumbai",
    "description": "Book Innova Car Hire Mumbai with professional chauffeurs for hassle-free travel across Mumbai and nearby destinations. Whether you require transportation for corporate events, family vacations, sightseeing, weddings, or long-distance travel, our Innova rental service offers comfort, flexibility, and reliable performance."
  },
  {
    "name": "Innova Taxi Service Mumbai",
    "description": "Choose Innova Taxi Service Mumbai for safe, comfortable, and punctual taxi services. Our chauffeur-driven Toyota Innova vehicles provide reliable transportation for airport transfers, city rides, outstation travel, corporate visits, family trips, and tourist sightseeing with affordable pricing."
  },
  {
    "name": "Innova with Driver Mumbai",
    "description": "Reserve Innova with Driver Mumbai for stress-free travel with skilled and courteous chauffeurs. Enjoy comfortable transportation for airport pickups, business meetings, local travel, shopping, family outings, and interstate journeys while relaxing in a spacious premium vehicle."
  },
  {
    "name": "Innova Outstation Cab Mumbai",
    "description": "Book Innova Outstation Cab Mumbai for comfortable long-distance travel across Maharashtra and India. Our AC Toyota Innova vehicles are ideal for one-way trips, round trips, pilgrimage tours, holiday travel, corporate visits, and family vacations with professional drivers and flexible itineraries."
  },
  {
    "name": "Innova Airport Taxi Mumbai",
    "description": "Choose Innova Airport Taxi Mumbai for timely airport pickup and drop services with flight tracking and professional chauffeurs. Enjoy spacious seating, extra luggage capacity, comfortable AC travel, and dependable transportation to and from Mumbai Airport."
  },
  {
    "name": "Innova Family Trip Cab Mumbai",
    "description": "Book Innova Family Trip Cab Mumbai for enjoyable journeys with your loved ones. The spacious cabin, comfortable seating, ample luggage space, and experienced chauffeurs make it an excellent choice for vacations, weekend getaways, religious tours, and sightseeing trips."
  },
  {
    "name": "Best Innova Rental Mumbai",
    "description": "Choose the Best Innova Rental Mumbai for premium chauffeur-driven travel with clean and well-maintained Toyota Innova vehicles. Enjoy professional drivers, transparent pricing, flexible booking options, spacious interiors, and reliable service for airport transfers, corporate travel, family vacations, outstation tours, religious journeys, and group transportation throughout Mumbai and beyond."
  }
],
"tableData": [
  ["Innova On Rent Mumbai", "Toyota Innova Rental Mumbai"],
  ["Innova Cab Mumbai", "Innova Car Hire Mumbai"],
  ["Innova Taxi Service Mumbai", "Innova with Driver Mumbai"],
  ["Innova Outstation Cab Mumbai", "Innova Airport Taxi Mumbai"],
  ["Innova Family Trip Cab Mumbai", "Best Innova Rental Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Premium Innova on Rent in Mumbai",
    WhyChoosedescription: "Shreesha Travels offers Toyota Innova on rent in Mumbai for family vacations, corporate travel, airport transfers, outstation journeys, weddings, and group tours. Enjoy spacious seating, comfortable interiors, and professional chauffeur-driven service."
  },
  {
    WhyChooseheading: "Perfect Choice for Comfortable Group Travel",
    WhyChoosedescription: "The Toyota Innova is an excellent option for families, business teams, tourists, and small groups looking for extra legroom, luggage space, and a smooth travel experience across Mumbai and beyond."
  },
  {
    WhyChooseheading: "Available for Local & Outstation Trips",
    WhyChoosedescription: "Hire an Innova for Mumbai city travel, airport transfers, corporate meetings, sightseeing, one-way drops, round trips, weekend getaways, and long-distance outstation journeys across India."
  },
  {
    WhyChooseheading: "Professional Chauffeurs & Reliable Service",
    WhyChoosedescription: "Our experienced drivers are familiar with Mumbai city roads, expressways, and interstate routes, ensuring punctual pickups, safe driving, and a comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Packages",
    WhyChoosedescription: "Choose from hourly rentals, full-day packages, airport transfers, one-way bookings, round trips, multi-day tours, and customized travel plans according to your requirements."
  },
  {
    WhyChooseheading: "Clean, Spacious & Well-Maintained Innova Cars",
    WhyChoosedescription: "Every Toyota Innova is regularly serviced, sanitized, air-conditioned, and inspected before every trip to provide maximum comfort, safety, and reliability."
  },
  {
    WhyChooseheading: "Ideal for Every Travel Occasion",
    WhyChoosedescription: "Our Innova rental service is suitable for family holidays, corporate transportation, pilgrimage tours, hotel transfers, destination weddings, business travel, and VIP guest movement."
  },
  {
    WhyChooseheading: "Book Innova on Rent in Mumbai with Shreesha Travels",
    WhyChoosedescription: "Experience affordable pricing, quick booking assistance, professional chauffeur service, and comfortable Toyota Innova rentals for every travel requirement in Mumbai."
  }
]

};

const faqData = [
  {
    question: "What is Toyota Innova rental service in Mumbai?",
    answer: "Shreesha Travels provides chauffeur-driven Toyota Innova rentals in Mumbai for local travel, airport transfers, corporate trips, outstation journeys, weddings, and family tours."
  },
  {
    question: "Can I hire an Innova for outstation travel from Mumbai?",
    answer: "Yes, Toyota Innova is available for one-way, round-trip, and multi-day outstation travel across Maharashtra and other Indian states."
  },
  {
    question: "Is the Toyota Innova suitable for family trips?",
    answer: "Yes, the Innova offers spacious seating, ample luggage capacity, and comfortable interiors, making it ideal for family vacations and long-distance travel."
  },
  {
    question: "Do you provide Innova rental for Mumbai Airport transfers?",
    answer: "Yes, Innova cars are available for airport pickup and drop services from both Mumbai Domestic and International Airport terminals."
  },
  {
    question: "Can I book an Innova for corporate travel?",
    answer: "Yes, our Toyota Innova rental service is suitable for business meetings, employee transportation, client visits, conferences, and executive travel."
  },
  {
    question: "Are chauffeur services included with the Innova rental?",
    answer: "Yes, every Toyota Innova rental includes a professional and experienced chauffeur for a safe and comfortable journey."
  },
  {
    question: "Is Innova available for weddings and special events?",
    answer: "Yes, Toyota Innova can be booked for weddings, family functions, VIP transportation, and special occasions."
  },
  {
    question: "How is the Innova rental fare calculated?",
    answer: "The rental cost depends on trip type, travel distance, rental duration, package selected, waiting time, tolls, and additional travel requirements."
  },
  {
    question: "Can I book an Innova for multiple days?",
    answer: "Yes, multi-day Innova rental packages are available for vacations, business tours, religious trips, and long-distance travel."
  },
  {
    question: "How can I book Innova on Rent in Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, travel date, itinerary, passenger count, and rental requirement to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Agarwal",
    feedback: "We hired an Innova for our family trip from Mumbai, and the experience was outstanding. The vehicle was spacious, clean, and the driver was very courteous.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Komal Shah",
    feedback: "Excellent Innova rental service with professional support. The car was well-maintained, comfortable for long-distance travel, and the booking process was quick and easy.",
    rating: 5
  }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova On Rent Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/innova-on-rent-mumbai.webp",
  "description":
    "Book Innova On Rent Mumbai with Shreesha Tours & Travels for comfortable and reliable taxi services. We provide Toyota Innova and Innova Crysta cabs with experienced drivers for local travel, airport transfers, outstation trips, family vacations, business travel, corporate travel, and long-distance journeys with 24x7 booking.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/innova-on-rent-mumbai"
  }
};




    return (
        <div>
<Helmet>
  <title>Innova On Rent Mumbai | Toyota Innova Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Innova On Rent Mumbai with Shreesha Travels for safe and comfortable taxi services. Hire Toyota Innova and Innova Crysta with experienced drivers for local travel, airport transfers, outstation trips, family tours, corporate travel, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Innova On Rent Mumbai, Toyota Innova Rental Mumbai, Innova Cab Mumbai, Innova Car Hire Mumbai, Innova Taxi Service Mumbai, Innova with Driver Mumbai, Innova Outstation Cab Mumbai, Innova Crysta Rental Mumbai, Innova for Family Trip Mumbai, Innova Airport Transfer Mumbai, Innova Cab Booking Mumbai, Toyota Innova Hire Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovaonrentmumbai;